export function addCalledServiceSettingsOrganizationFieldValidation(calledservicesettingsorganizationfieldvalidation) {
  return {
      type: 'ADD_CALLED_SERVICE_SETINGS_ORGANIZATION_FIELD_VALIDATION',
      calledservicesettingsorganizationfieldvalidation,
  }
}